import PropTypes from 'prop-types';
import { useSelector } from 'react-redux';
import { getIsInNonDefaultBreakpointMode } from 'ContentEditorUI/redux/selectors/styleBreakpointsSelectors';
import MobileSidebarOverlay from './MobileSidebarOverlay';
import { jsx as _jsx } from "react/jsx-runtime";
const MobileSidebarOverlayContainer = ({
  modalMessageKey,
  overlayClassName,
  hasSmartRuleSelected
}) => {
  const isInNonDefaultBreakpointMode = useSelector(getIsInNonDefaultBreakpointMode);
  if (isInNonDefaultBreakpointMode || hasSmartRuleSelected) {
    return /*#__PURE__*/_jsx(MobileSidebarOverlay, {
      modalMessageKey: modalMessageKey,
      overlayClassName: overlayClassName,
      messageTitle: hasSmartRuleSelected ? 'addModule.smartRulesStyles.title' : 'addModule.mobile.title'
    });
  }
  return null;
};
MobileSidebarOverlayContainer.propTypes = {
  modalMessageKey: PropTypes.string.isRequired,
  overlayClassName: PropTypes.string,
  hasSmartRuleSelected: PropTypes.number
};
export default MobileSidebarOverlayContainer;